import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
} from '@mui/material'
import { memo } from 'react'
import { InsuranceFund, getInsuranceFund } from 'api/v1/information'
import { atom, useAtomValue } from 'jotai'
import { PRIMARY_CURRENCY } from 'constants/currencies'
import { DateFormatter } from 'utils/datetime'
import { toFixed } from 'utils/number'
import { insuranceFundAtom } from '../Information/Tabs/InsuranceFund'

const Wrap = styled(Stack)`
  padding: 8px 24px 24px;
`
const Title = styled('h2')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  margin: 0;
`
const Body = styled('div')`
  padding: 16px 0;
`
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: 'rgba(123, 136, 145, 1)',
    lineHeight: '18px',
    padding: '11px 16px',
    borderBottomColor: 'rgba(46, 54, 59, 1)',
  },
  [`&.${tableCellClasses.body}`]: {
    color: 'rgba(229, 234, 238, 1)',
    fontSize: 14,
    borderBottomColor: 'rgba(46, 54, 59, 1)',
  },
}))

export const InsuranceFundView = memo(() => {
  const insuranceFund = useAtomValue(insuranceFundAtom)

  return (
    <Wrap>
      <Title>Insurance Fund History</Title>
      <Body>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Time</StyledTableCell>
                <StyledTableCell>
                  Insurance Fund Balance ({PRIMARY_CURRENCY})
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {insuranceFund.map((item) => (
                <TableRow key={item.createdAt}>
                  <StyledTableCell>
                    {DateFormatter.toISODateTime(item.createdAt)}
                  </StyledTableCell>
                  <StyledTableCell>
                    {toFixed(item.amount, 4, { fixed: true })}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Body>
    </Wrap>
  )
})
